export default "__VITE_ASSET__DqqOXJ0___"